export const homeBannerAddComponent = {

	//passing title and onSubmit function for binding in main component
	template: `
		<home-banner-main 
			page-title='Add Banner'
			parent-slug='{{$ctrl.parentSlug}}' 
			disable-buttons='$ctrl.disableButtons'
			on-submit='$ctrl.onSubmit(details)'>
		</home-banner-main>`,

	bindings: {
		parentSlug: '@',
		slugUrl: '@'
	},

	//controller for HomeBannerAddComponent
	controller: class HomeBannerAddComponent {
		constructor($stateParams, toastr, $state, HomeBannerService, DynamicMenusService, SlugService) {
			'ngInject';

			this.$stateParams = $stateParams;
			this.toastr = toastr;
			this.$state = $state;
			this.homeBannerService = HomeBannerService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		//function to add class details
		onSubmit(details) {
			this.disableButtons = true;
			const url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
			details = this.homeBannerService._setBannerObject(details);

			// submit the request
			this.dynamicMenusService.addMenuDetailsByUrl(url, details)
				.then((details) => {
					this.toastr.success('Banner added successfully');
					this._redirectToParentState(this.parentSlug);
					this.disableButtons = false;
				}).catch((err) => {
					this.toastr.error(err);
					this.disableButtons = false;
				});
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/home-banner/home-banner-add/home-banner-add.component.js